import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './LandingPage';
import Hue from './components/Hue';
import Menu from './components/Menu';
// import LoginPage from './components/LoginPage';
// import StoreLogin from './components/StoreLogin';
import Wiki from './components/Wiki';
import Contact from './components/Contact';
import TermsOfUse from './components/TermsOfUse';
import Vecinos from './pages/Vecinos';
import Support from './pages/Support';
import Legal from './pages/Legal';
import About from './pages/About';
import Press from './pages/Press';
import Blog from './pages/Blog';


function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/vecinos" element={<><Menu /><Vecinos /></>} />
        <Route path="/support" element={<><Menu /><Support /></>} />
        <Route path="/terms" element={<><Menu /><Legal type="terms" /></>} />
        <Route path="/privacy" element={<><Menu /><Legal type="privacy" /></>} />
        <Route path="/about" element={<><Menu /><About /></>} />
        <Route path="/press" element={<><Menu /><Press /></>} />
        <Route path="/blog" element={<><Menu /><Blog /></>} />
        <Route path="/hue" element={<><Menu /><Hue /></>} />
        {/* <Route path="/login" element={<><Menu /><LoginPage /></>} /> */}
        {/* <Route path="/storelogin" element={<><Menu /><StoreLogin /></>} /> */}
        <Route path="/contact" element={<><Menu /><Contact /></>} />
        <Route path="/wiki" element={<><Menu /><Wiki /></>} />
        <Route path="/termsofuse" element={<><Menu /><TermsOfUse /></>} />
      </Routes>
    </div>
  );
}


export default App;
